module.exports = __webpack_public_path__ + "img/interbank-2.4ac8ac7b.svg";